import {
  Component,
  OnInit,
  inject,
  input,
  InputSignal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { AlfredClientService } from '../../alfred-client.service';
import { ThankYouStep } from '../../models/step/thank-you-step.model';
import { ThankYouType } from '../../shared/enums/thank-you-type.enum';
import { CloseButtonComponent } from '../../shared/close-button/close-button.component';
import { IonButton } from '@ionic/angular/standalone';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lib-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss'],
  imports: [CloseButtonComponent, IonButton],
})
export class ThankYouComponent implements OnInit {
  public alfredClientOutputService: AlfredClientService =
    inject(AlfredClientService);

  /**
   * The thank-you object of the step
   */
  public readonly step: InputSignal<ThankYouStep> =
    input.required<ThankYouStep>();

  /**
   * @inheritDoc
   */
  public ngOnInit(): void {
    const step: ThankYouStep = this.step();
    if (step.thankYouType === ThankYouType.URL) {
      window.open(step.url);
    }
    // This is a fallback in case the last question is part of a condition group.
    // See docs.
    if (step.thankYouType === ThankYouType.RETURN) {
      this.alfredClientOutputService.finish();
    }
  }

  /**
   * Open the url in a new browser tab
   */
  public openThankYouUrl(): void {
    window.open(this.step().url, '__blank');
  }
}
